import { Button, Card, Form, Icon, Input, Spin, Tooltip } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/SubList";
import ColorPicker from "../ColorPicker";

// System reserved status names whose name cannot be changed (mirrors backend StatusService).
const RESERVED_STATUS_NAMES = ['New', 'Closed', 'Cancelled', 'Reopened', 'Open', 'Done', 'Uncancelled'];
const isReservedStatus = (name) =>
  Boolean(name) && RESERVED_STATUS_NAMES.some((reserved) => reserved.toLowerCase() === String(name).trim().toLowerCase());

class Create extends React.Component {

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      console.log('values', values);
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource} />
              } else {
                if (item === 'name' && title === 'EDIT' && isReservedStatus(data.name)) {
                  // System reserved status — name is locked and cannot be renamed.
                  return (
                    <Form.Item key={item} label={
                      <span>{sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}&nbsp;
                        <Tooltip title="System reserved status — the name cannot be changed">
                          <Icon type="lock" />
                        </Tooltip>
                      </span>}>
                      {getFieldDecorator(item, {
                        initialValue: data[item],
                      })(<Input disabled autoComplete={'off'} />)}
                    </Form.Item>
                  )
                } else if (item === 'statusColor') {
                  return (
                    <Form.Item label={filters[item].label}>
                      {getFieldDecorator(`${item}`, {
                        rules: [{ required: true, message: 'Please select a color' }],
                        initialValue: data[item] || '#000000',
                      })(<ColorPicker color={data[item] || '#000000'} type="sketch" onChange={(color) => {
                        console.log('color', color);
                      }} />)
                      }
                    </Form.Item>
                  )
                } else
                  return getFormFieldByType(filters, item, getFieldDecorator, data)
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
